var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseFormInput',_vm._g(_vm._b({attrs:{"formatter":_vm.currencyFormatter,"input-class":_vm.inputClass},scopedSlots:_vm._u([{key:"helpText",fn:function(){return [_vm._t("helpText")]},proxy:true}],null,true)},'BaseFormInput',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }